<template>
  <div class="meterWrap">
    <div class="main-area">
      <!-- 左侧可折叠组织树 + 监测点位 -->
      <CollapsibleTreeWithSites
        :visible="leftTreeVisible"
        @toggle="leftTreeVisible = !leftTreeVisible"
        @node-click="handleNodeClick"
        @site-click="handleSiteClick"
        ref="treeWithSites"
      />

      <!-- 右侧内容卡片 -->
      <div class="content-card">
        <!-- 顶栏：模式切换 + 时间选择 + 导出 -->
        <div class="time-bar">
          <div class="toggle-group">
            <span
              class="toggle-btn"
              :class="{ active: timeAct === '1' }"
              @click="actItem('1')"
            >总体统计</span>
            <span
              class="toggle-btn"
              :class="{ active: timeAct === '2' }"
              @click="actItem('2')"
            >分点统计</span>
          </div>

          <div class="time-selector">
            <template v-if="timeAct === '1'">
              <el-date-picker
                v-model="startDate"
                style="width: 200px"
                value-format="yyyy-MM-dd"
                placeholder="起始时间"
                type="date"
                :clearable="false"
              />
              <span class="time-sep">~</span>
              <el-date-picker
                v-model="endDate"
                style="width: 200px"
                value-format="yyyy-MM-dd"
                placeholder="结束时间"
                type="date"
                :clearable="false"
              />
            </template>
            <template v-else>
              <el-date-picker
                v-model="startDatetime"
                style="width: 220px"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                placeholder="起始时间"
                type="datetime"
                :clearable="false"
              />
              <span class="time-sep">~</span>
              <el-date-picker
                v-model="endDatetime"
                style="width: 220px"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                placeholder="结束时间"
                type="datetime"
                :clearable="false"
              />
            </template>
          </div>

          <el-button
            type="primary"
            size="small"
            @click="timeAct === '1' ? printOutAll() : printOutSingle()"
          >导出</el-button>
        </div>

        <!-- 总体统计内容 -->
        <div class="content-body" v-show="timeAct === '1'">
          <div class="table-box full">
            <el-table
              v-loading="loading"
              height="100%"
              :data="allList"
              class="stat-table"
              border
            >
              <el-table-column
                label="监测点名称"
                prop="monitorSiteName"
                min-width="200"
                show-overflow-tooltip
                align="center"
              />
              <el-table-column
                label="能耗统计值"
                prop="energySum"
                min-width="110"
                align="center"
              />
              <el-table-column
                label="当前电度值"
                prop="currentDegree"
                min-width="110"
                align="center"
              />
              <el-table-column
                label="上期电度值"
                prop="previousDegree"
                min-width="110"
                align="center"
              />
            </el-table>
          </div>
          <div class="page-bar">
            <el-pagination
              @current-change="pageChange"
              background
              :current-page="page"
              :page-size="pageNum"
              layout="total, prev, pager, next, jumper"
              :total="pageSize"
            />
          </div>
        </div>

        <!-- 分点统计内容 -->
        <div class="content-body" v-show="timeAct === '2'">
          <div class="table-box full">
            <el-table
              v-loading="loading"
              height="100%"
              :data="cavdata"
              class="stat-table"
              border
            >
              <el-table-column label="时间" prop="time" show-overflow-tooltip align="center" />
              <el-table-column label="合成有功电能" prop="p_total" show-overflow-tooltip align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "utils/Axios";
import axios from "axios";
import qs from "qs";
import CollapsibleTreeWithSites from "components/CollapsibleTreeWithSites.vue";

export default {
  name: "energyMeter",
  components: { CollapsibleTreeWithSites },
  data() {
    return {
      leftTreeVisible: true,
      timeAct: "1",
      deptId: "",
      monitorSiteId: "",

      // 总体统计
      startDate: "",
      endDate: "",
      allList: [],
      page: 1,
      pageNum: 20,
      pageSize: 0,

      // 分点统计
      startDatetime: "",
      endDatetime: "",
      cavdata: [],

      loading: false,
    };
  },
  mounted() {
    this.getNowTime();
  },
  watch: {
    startDate() { this.getTableData(); },
    endDate() { this.getTableData(); },
  },
  methods: {
    /* ========== 时间初始化 ========== */
    getNowTime() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      const h = String(now.getHours()).padStart(2, "0");

      this.startDate = y + "-" + String(now.getMonth()).padStart(2, "0") + "-" + d;
      this.endDate = y + "-" + m + "-" + d;
      this.startDatetime = y + "-" + String(now.getMonth()).padStart(2, "0") + "-" + d + " " + h + ":00:00";
      this.endDatetime = y + "-" + m + "-" + d + " " + h + ":00:00";
    },

    /* ========== 模式切换 ========== */
    actItem(val) {
      this.timeAct = val;
    },

    /* ========== 组织树点击 — 总体统计直接联动，分点统计等待点位选择 ========== */
    handleNodeClick(node) {
      this.deptId = node.deptId;
      if (this.timeAct === "1") {
        this.page = 1;
        this.getTableData();
      }
      // timeAct === '2' 时：树点击后左侧会加载点位列表（由 CollapsibleTreeWithSites 内部处理），
      // 用户点击点位后再触发 handleSiteClick
    },

    /* ========== 监测点位点击（分点统计用） ========== */
    handleSiteClick(item) {
      if (this.timeAct !== "2") return;
      this.monitorSiteId = item.id;
      this.getFirData();
    },

    /* ========== API — 总体统计表格 ========== */
    getTableData() {
      if (!this.deptId) return;
      this.loading = true;
      Axios.ajax({
        method: "post",
        url: "/portal/energyMeterPage",
        data: {
          pageNum: this.page,
          showNum: this.pageNum,
          endDate: this.endDate,
          startDate: this.startDate,
          deptId: this.deptId,
        },
      })
        .then((res) => {
          if (res.resultCode == 0) {
            this.allList = res.data.dataList || [];
            this.pageSize = res.data.totalNum || 0;
          } else {
            this.$message.warning(res.resultMessage);
          }
        })
        .finally(() => { this.loading = false; });
    },

    /* ========== API — 分点统计冻数据 ========== */
    getFirData() {
      if (!this.monitorSiteId) return;
      this.loading = true;
      Axios.ajax({
        method: "post",
        url: "/analogData/hourFreezeDataInfoV3",
        data: qs.stringify({
          monitorSiteId: this.monitorSiteId,
          params: "P_total",
          startTime: this.startDatetime,
          endTime: this.endDatetime,
        }),
      })
        .then((res) => {
          this.cavdata = [];
          if (Array.isArray(res.data.freezeDatas)) {
            this.cavdata = res.data.freezeDatas.slice(1).map((item) => ({
              time: item[0],
              p_total: item[1],
            }));
          }
        })
        .finally(() => { this.loading = false; });
    },

    /* ========== 分页 ========== */
    pageChange(val) {
      this.page = val;
      this.getTableData();
    },

    /* ========== 导出 — 总体统计 ========== */
    printOutAll() {
      axios({
        methods: "get",
        url: this.baseUrl + "portal/exportEnergyMeter",
        params: {
          endDate: this.endDate,
          startDate: this.startDate,
          deptId: this.deptId,
        },
        responseType: "blob",
      }).then((res) => {
        const aLink = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8" });
        aLink.href = URL.createObjectURL(blob);
        aLink.download = this.startDate + "-" + this.endDate + ".xls";
        aLink.click();
        document.body.appendChild(aLink);
      });
    },

    /* ========== 导出 — 分点统计 ========== */
    printOutSingle() {
      if (!this.monitorSiteId) {
        this.$message.warning("请先选择监测点位");
        return;
      }
      axios({
        methods: "get",
        url: this.baseUrl + "/analogData/exportHourFreezeDataV3",
        params: {
          monitorSiteId: this.monitorSiteId,
          params: "P_total",
          startTime: this.startDatetime,
          endTime: this.endDatetime,
        },
        responseType: "blob",
      }).then((res) => {
        const aLink = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8" });
        aLink.href = URL.createObjectURL(blob);
        aLink.download = this.startDatetime + "-" + this.endDatetime + ".xls";
        aLink.click();
        document.body.appendChild(aLink);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.meterWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-area {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 12px;
  overflow: hidden;
}

/* ========== 右侧内容卡片 ========== */
.content-card {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ========== 顶栏 ========== */
.time-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;

  .toggle-group {
    display: flex;
    gap: 6px;
    flex-shrink: 0;

    .toggle-btn {
      width: 80px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      color: #7d879f;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover { color: #2a62ff; border-color: #2a62ff; }
      &.active {
        color: #2a62ff;
        border-color: #2a62ff;
        background: rgba(42, 98, 255, 0.06);
      }
    }
  }

  .time-selector {
    display: flex;
    align-items: center;
    gap: 4px;

    .time-sep {
      color: #909399;
      font-size: 13px;
    }

    /* ponytail: 让日期选择器输入文字与图标不重叠 */
    :deep(.el-date-editor) {
      .el-input__prefix { left: 8px; }
      .el-input__inner { padding-left: 32px; }
    }
  }
}

/* ========== 内容主体 ========== */
.content-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  overflow: hidden;

  .table-box {
    flex: 1;
    min-height: 0;
    overflow: hidden;

    &.full {
      width: 100%;
    }
  }

  .page-bar {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
  }
}

/* ========== 表格统一样式 ========== */
.stat-table {
  width: 100%;
}
</style>
